<template>
  <card id="applicatie" ref="applicationref">
    <template slot="header">
        <div style="float: right">
            <base-button v-if="(loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN) && isCN" type="warning" size="lg" class="btn-fill"  v-on:click="exportConceptNoteBulk">
                Export list
            </base-button>
        </div>
        <h2 slot="header" class="card-title">{{$t('applications.admin__applications')}}</h2>
    </template>
    <!--<h2 slot="header" class="card-title">{{$t('applications.admin__applications')}}</h2>-->
    <div class="row">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <div>
            <tabs ref="tab-grants" type="info" @activate-tab="activateTab" square>
              <tab-pane :id="'grants_' + grant.grantId" :label="grant.description" v-for="grant in grants" v-bind:key="grant.grantId">
                
                <!-- cn toggle-by alan -->
                <!--<div v-if="grant.grantId == 2" class="mb-4">
                                    <p class="category" style="font-size: 16px; margin-bottom: 10px;">Concept Note / Full Proposal</p>
                                    <base-switch v-model="isCN" type="info" @input="handleFilters(grant.grantId)" on-text="CN" off-text="MG" style="transform: scale(1.4) translate(10px, 3px)"></base-switch>
                                </div>-->

                <!-- 2019/2022 tabs-->
                <div v-if="grant.grantId == 2" class="mb-4">
                  <base-button label="2022" class="mb-1 ml-0" :type="btntype22" size="sm" @click="yearWiseMediumGrant('2022',grant.grantId)">2022</base-button>
                  <base-button label="2019" class="mb-1" :type="btntype19" size="sm" @click="yearWiseMediumGrant('2019',grant.grantId)">2019</base-button>
                  <!-- cn toggle-by alan -->
                  <div v-show="showToggle">               
                    <p class="category" style="font-size: 16px; margin-bottom: 10px;">Concept Note / Full Proposal</p>
                          <base-switch v-model="isCN" type="info" @input="handleFilters(grant.grantId)" on-text="CN" off-text="FP" style="transform: scale(1.4) translate(10px, 3px)"></base-switch>
                  </div>
                </div>

                <div v-if="grant.grantId == 3" class="mb-4">
                  <base-button label="2022" class="mb-1 ml-0" :type="btntype22" size="sm" @click="yearWiseMediumGrant('2022',grant.grantId)">2022</base-button>
                  <base-button label="2019" class="mb-1" :type="btntype19" size="sm" @click="yearWiseMediumGrant('2019',grant.grantId)">2019</base-button>
                </div>

                <!-- Full proposal Filters-->
                <div v-if="!isCN" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                  <div>
                    <el-select class="filter-select mr-2" v-model="filters.status" placeholder="Filter by status" clearable @change="handleFilters(grant.grantId)">
                      <el-option v-for="item in filterOptions.status" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                    </el-select>
                    <el-select class="filter-select mr-2" v-model="filters.final_status" placeholder="Filter by awarded status" clearable @change="handleFilters(grant.grantId)">
                      <el-option v-for="item in filterOptions.final_status" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                    </el-select>
                    <el-select class="filter-select mr-2" v-model="filters.regions" multiple collapse-tags placeholder="Filter by regions" clearable @change="handleFilters(grant.grantId)">
                      <el-option v-for="item in filterOptions.regions" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                    </el-select>
                    <el-select class="filter-select mr-2" v-model="filters.countries" multiple collapse-tags placeholder="Filter by countries" clearable @change="handleFilters(grant.grantId)">
                      <el-option v-for="item in filterOptions.countries" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                    </el-select>
                    <el-select class="filter-select mr-2" v-model="filters.language" placeholder="Filter by language" clearable @change="handleFilters(grant.grantId)">
                      <el-option v-for="item in filterOptions.language" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                    </el-select>
                  </div>
                  <base-input>
                    <el-input
                      type="text"
                      class="mb-3 search-input"
                      prefix-icon="el-icon-search"
                      placeholder="Search and hit enter"
                      v-model="searchQuery"
                      @keyup.native.enter="getItems(1)"
                    >
                    </el-input>
                  </base-input>
                </div>
                
                <!--Full proposal table-->
                <el-table v-if="!isCN" :data="grant.applications" @sort-change="handleSort">
                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <div>Name:
                        <a class="link-text" @click="viewUserProfile(props.row.user_details.id)"> {{ props.row.user_details.name }}</a>
                      </div>
                      <div>Email: {{ props.row.user_details.email }}</div>
                      <div>Language:
                        <flag :iso="languages[props.row.user_details.language].flag" v-bind:squared=false></flag>
                        {{ props.row.user_details.language }}
                      </div>
                      <div>Phone: {{ props.row.user_details.phone }}</div>
                      <div class="mt-2">
                        Evaluations:
                      </div>
                      <ol v-if="props.row.cn_evaluation_status != 'Preselected' && props.row.new_application == 0">
                        <li v-for="evaluationType in evaluationTypes" :key="evaluationType.id" v-if="evaluationType.fp == 1">
                          <a @click="evaluateApplication(props.row, evaluationType)" class="pl-1 link-text"> {{evaluationType.name}} </a>
                          <ul class="evaluations-list">
                            <li v-if="applicationEvaluation.type.nickname === evaluationType.nickname" v-for="applicationEvaluation in props.row.evaluations" :key="applicationEvaluation.id">
                              <span v-if="evaluationType.nickname === 'technical'">
                      <a @click="evaluateApplication(props.row, evaluationType, applicationEvaluation.user_id)" class="pl-1 link-text"> {{applicationEvaluation.status}} </a>
                    ({{applicationEvaluation.user.name}})
                  </span> <span v-else>{{applicationEvaluation.status}} ({{applicationEvaluation.user.name}})</span>
                            </li>
                          </ul>
                        </li>
                      </ol>
                      <ol v-if="props.row.cn_evaluation_status != 'Preselected' && props.row.new_application == 1">
                        <li v-for="evaluationType in evaluationTypes" :key="evaluationType.id" v-if="evaluationType.fp == -1">
                          <a @click="evaluateApplication(props.row, evaluationType)" class="pl-1 link-text"> {{evaluationType.name}} </a>
                          <ul class="evaluations-list">
                            <li v-if="applicationEvaluation.type.nickname === evaluationType.nickname" v-for="applicationEvaluation in props.row.evaluations" :key="applicationEvaluation.id">
                              <span v-if="evaluationType.nickname === 'technical'">
                      <a @click="evaluateApplication(props.row, evaluationType, applicationEvaluation.user_id)" class="pl-1 link-text"> {{applicationEvaluation.status}} </a>
                    ({{applicationEvaluation.user.name}})
                  </span> <span v-else>{{applicationEvaluation.status}} ({{applicationEvaluation.user.name}})</span>
                            </li>
                          </ul>
                        </li>
                      </ol>
                      <ol v-if="props.row.cn_evaluation_status == 'Preselected'">
                        <li v-for="evaluationType in evaluationTypes" :key="evaluationType.id" v-if="evaluationType.fp == -1">
                          <a @click="evaluateApplication(props.row, evaluationType)" class="pl-1 link-text"> {{evaluationType.name}} </a>
                          <ul class="evaluations-list">
                            <li v-if="applicationEvaluation.type.nickname === evaluationType.nickname" v-for="applicationEvaluation in props.row.evaluations" :key="applicationEvaluation.id">
                              <span v-if="evaluationType.nickname === 'technical'">
                      <a @click="evaluateApplication(props.row, evaluationType, applicationEvaluation.user_id)" class="pl-1 link-text"> {{applicationEvaluation.status}} </a>
                    ({{applicationEvaluation.user.name}})
                  </span> <span v-else>{{applicationEvaluation.status}} ({{applicationEvaluation.user.name}})</span>
                            </li>
                          </ul>
                        </li>
                      </ol>
                    </template>
                  </el-table-column>
                  <el-table-column
                    sortable
                    label="Reference"
                    min-width="50"
                    property="reference"
                  ></el-table-column>
                  <el-table-column
                    sortable
                    label="Title"
                    property="title"
                    prop="title"
                  ></el-table-column>
                  <!--<el-table-column
                    label="Organisation"
                    property="user_details.fields.organisation_legal_name"
                  >
                    <div slot-scope="props" v-if="props.row.user_details.fields">
                      {{props.row.user_details.fields.organisation_legal_name}}
                    </div>
                  </el-table-column>-->
                  <el-table-column
                    label="Organisation"
                    property="data.technical.name_of_lead_org"
                  >
                    <div slot-scope="props" v-if="props.row.data">
                      {{props.row.data.technical.name_of_lead_org}}
                    </div>
                  </el-table-column>
                  <el-table-column
                    label="Objectives"
                    max-width="50"
                    property="objectives"
                  ></el-table-column>
                  <el-table-column
                    sortable
                    label="Status"
                    max-width="50"
                    property="status"
                  >
                    <div slot-scope="props">
                      <span v-if="props.row.status === 'submitted'" class="badge badge-success">{{props.row.status}}</span>
                      <span v-if="props.row.status !== 'submitted'" class="badge">{{props.row.status}}</span>
                    </div>
                  </el-table-column>
                  <el-table-column
                    sortable
                    label="Awarded Status"
                    max-width="50"
                    property="final_status"
                  >
                  </el-table-column>
                  <el-table-column
                    sortable
                    label="Final Mark"
                    max-width="50"
                    property="final_result_score"
                  >
                  </el-table-column>
                  <el-table-column
                    sortable
                    label="Submitted At"
                    max-width="50"
                    property="submitted_at"
                  >
                    <div slot-scope="props">
                      <span v-if="props.row.status === 'submitted'">{{props.row.submitted_at}}</span>
                      <span v-if="props.row.status !== 'submitted'">Not submitted</span>
                    </div>
                  </el-table-column>
                  <el-table-column align="right" min-width="150" label="Actions">
                    <div slot-scope="props">
                      <div class="card-body">
                        <div>
                            <base-button
                              class="mb-1"
                              type="info"
                              size="sm"
                              @click="viewApplication(props.row, true)"
                            >
                              <i class="tim-icons icon-zoom-split"></i> View Application
                            </base-button>
                        </div>
                        <div class="btn-group dropdown" v-if="loggedUser.role !== UserRoles.AUDITOR">
                          <base-button
                            class="mb-1"
                            type="warning"
                            size="sm"
                            @click="evaluateApplicationModal(props.row)"
                          >
                            <i class="tim-icons icon-paper"></i> Evaluate
                          </base-button>
                            <base-button
                              class="mb-1"
                              type="warning"
                              size="sm"
                              data-toggle="dropdown"
                              >
                              <i class="tim-icons icon-cloud-download-93"></i>
                            </base-button>
                            <ul class="dropdown-menu">
                              <li><a @click="exportEvaluation(props.row.application_id, 'all')">Export All</a></li>
                              <li v-for="applicationEvaluation in props.row.evaluations" :key="applicationEvaluation.id">
                                <a @click="exportEvaluation(props.row.application_id, evaluationTypes.find(function (i) { return i.evaluation_type_id === applicationEvaluation.evaluation_type_id }).nickname)">{{ (evaluationTypes.find(function (i) { return i.evaluation_type_id === applicationEvaluation.evaluation_type_id }) || {name: ''}).name }}</a>
                              </li>
                            </ul>
                        </div>
                        <base-button
                            v-if="loggedUser.role !== UserRoles.AUDITOR"
                          class="mb-1"
                          type="success"
                          size="sm"
                          @click="requestClarifications(props.row)"
                        >
                          <i class="tim-icons icon-alert-circle-exc"></i> Request Clarifications
                        </base-button>
                        <base-button
                            v-if="loggedUser.role !== UserRoles.AUDITOR"
                          class="mb-1"
                          :type="props.row.has_revision ? 'green' : 'orange'"
                          size="sm"
                          @click="requestRevision(props.row)"
                        >
                          <i class="tim-icons icon-zoom-split"></i> {{ (props.row.has_revision ? 'Open for Revision' : 'Request Revision') }}
                        </base-button>
                      </div>
                    </div>
                  </el-table-column>
                </el-table>
                <div
                  v-if="grant.pagination && !isCN"
                  class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                  <div class="">
                    <p class="card-category">
                      Showing {{ grant.pagination.from }} to {{ grant.pagination.to }} of {{ grant.pagination.total }} entries
                    </p>
                  </div>
                  <base-pagination
                    v-if="grant.applications.length"
                    @input="getItems"
                    class="pagination-no-border"
                    v-model="grant.pagination.current_page"
                    :per-page="grant.pagination.per_page"
                    :total="grant.pagination.total"
                  >
                  </base-pagination>
                </div>
                <!-- Concept notes filter-->
              <div v-if="isCN" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                  <div>
                    <el-select class="filter-select mr-2" v-model="cnfilters.status" placeholder="Filter by concept application status" clearable @change="handleFilters(grant.grantId)">
                      <el-option v-for="item in cnfilterOptions.status" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                    </el-select>
                    <el-select class="filter-select mr-2" v-model="cnfilters.evaluation_status" placeholder="Filter by concept awarded status" clearable @change="handleFilters(grant.grantId)">
                      <el-option v-for="item in cnfilterOptions.evaluation_statuses" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                    </el-select>
                    <el-select class="filter-select mr-2" v-model="cnfilters.regions" multiple collapse-tags placeholder="Filter by regions" clearable @change="handleFilters(grant.grantId)">
                      <el-option v-for="item in cnfilterOptions.regions" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                    </el-select>
                    <el-select class="filter-select mr-2" v-model="cnfilters.countries" multiple collapse-tags placeholder="Filter by countries" clearable @change="handleFilters(grant.grantId)">
                      <el-option v-for="item in cnfilterOptions.countries" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                    </el-select>
                    <el-select class="filter-select mr-2" v-model="cnfilters.language" placeholder="Filter by language" clearable @change="handleFilters(grant.grantId)">
                      <el-option v-for="item in cnfilterOptions.language" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                    </el-select>
                  </div>
                  <base-input>
                    <el-input
                      type="text"
                      class="mb-3 search-input"
                      prefix-icon="el-icon-search"
                      placeholder="Search and hit enter"
                      v-model="searchQuery"
                      @keyup.native.enter="getItems(1)"
                    >
                    </el-input>
                  </base-input>
                </div>
                <!-- Concept notes List-->
                <el-table :data="grant.cnapplications" v-if="isCN && grant.cnStatus == 1" @sort-change="handleSort">
                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <div>Name:
                        <a class="link-text" @click="viewUserProfile(props.row.user_details.id)"> {{ props.row.user_details.name }}</a>
                      </div>
                      <div>Email: {{ props.row.user_details.email }}</div>
                      <div>Language:
                        <flag :iso="languages[props.row.user_details.language].flag" v-bind:squared=false></flag>
                        {{ props.row.user_details.language }}
                      </div>
                      <div>Phone: {{ props.row.user_details.phone }}</div>
                      <div class="mt-2">
                        Evaluations:
                      </div>
                      <ol>
                        <li v-for="evaluationType in evaluationTypes" :key="evaluationType.id" v-if="evaluationType.fp == 0">
                          <a @click="evaluateApplication(props.row, evaluationType)" class="pl-1 link-text"> {{evaluationType.name}} </a>
                          <ul class="evaluations-list">
                            <li v-if="applicationEvaluation.type.nickname === evaluationType.nickname" v-for="applicationEvaluation in props.row.evaluations" :key="applicationEvaluation.id">
                              <span v-if="evaluationType.nickname === 'technical'">
                      <a @click="evaluateApplication(props.row, evaluationType, applicationEvaluation.user_id)" class="pl-1 link-text"> {{applicationEvaluation.status}} </a>
                    ({{applicationEvaluation.user.name}})
                  </span> <span v-else>{{applicationEvaluation.status}} ({{applicationEvaluation.user.name}})</span>
                            </li>
                          </ul>
                        </li>
                      </ol>
                    </template>
                  </el-table-column>

                  <el-table-column
                    sortable
                    label="Reference"
                    min-width="50"
                    property="reference"
                  ></el-table-column>

                  <!--<el-table-column
                    label="Organisation"
                    property="user_details.fields.organisation_legal_name"
                  >
                    <div slot-scope="props" v-if="props.row.user_details.fields">
                      {{props.row.user_details.fields.organisation_legal_name}}
                    </div>
                  </el-table-column>-->
                  <el-table-column
                    label="Organisation"
                    property="data.cndescription.name_of_lead_org"
                  >
                    <div slot-scope="props" v-if="props.row.data.cndescription">
                      {{props.row.data.cndescription.name_of_lead_org}}
                    </div>
                  </el-table-column>

                  <el-table-column
                    sortable
                    label="Concept Application Status"
                    max-width="90"
                    property="cn_status"
                  >
                    <div slot-scope="props">
                      <span v-if="props.row.cn_status === 'SUBMITTED'" class="badge badge-success">{{props.row.cn_status}}</span>
                      <span v-if="props.row.cn_status !== 'SUBMITTED'" class="badge">{{props.row.cn_status}}</span>
                    </div>
                  </el-table-column>

                  <el-table-column
                    sortable
                    label="Concept Evaluation Status"
                    max-width="90"
                    property="cn_evaluation_status"
                  >
                  </el-table-column>
                  
                  <el-table-column
                    sortable
                    label="Submitted At"
                    max-width="50"
                    property="cn_submitted_at"
                  >
                    <div slot-scope="props">
                      <span v-if="props.row.cn_status === 'SUBMITTED'">{{props.row.cn_submitted_at}}</span>
                      <span v-if="props.row.cn_status !== 'SUBMITTED'">Not submitted</span>
                    </div>
                  </el-table-column>
                  <el-table-column align="right" min-width="130" label="Actions">
                    <div slot-scope="props">
                      <div class="card-body">
                        <div>
                            <base-button
                              class="mb-1"
                              type="info"
                              size="sm"
                              @click="viewApplication(props.row, true)"
                            >
                              <i class="tim-icons icon-zoom-split"></i> View Application
                            </base-button>
                        </div>
                        <div class="btn-group dropdown" v-if="loggedUser.role !== UserRoles.AUDITOR && props.row.cn_status == 'SUBMITTED'">
                          <base-button
                            class="mb-1"
                            type="warning"
                            size="sm"
                            @click="evaluateApplicationModal(props.row)"
                          >
                            <i class="tim-icons icon-paper"></i> Evaluate
                          </base-button>
                            <base-button
                              class="mb-1"
                              type="warning"
                              size="sm"
                              data-toggle="dropdown"
                              >
                              <i class="tim-icons icon-cloud-download-93"></i>
                            </base-button>
                            <ul class="dropdown-menu">
                              <li><a @click="exportConceptEvaluation(props.row.application_id, 'all')">Export All</a></li>
                              <li v-for="applicationEvaluation in props.row.evaluations" :key="applicationEvaluation.id">
                                <a @click="exportConceptEvaluation(props.row.application_id, evaluationTypes.find(function (i) { return i.evaluation_type_id === applicationEvaluation.evaluation_type_id }).nickname)">{{ (evaluationTypes.find(function (i) { return i.evaluation_type_id === applicationEvaluation.evaluation_type_id }) || {name: ''}).name }}</a>
                              </li>
                            </ul>
                        </div>
                        <base-button
                            v-if="loggedUser.role !== UserRoles.AUDITOR"
                          class="mb-1"
                          type="success"
                          size="sm"
                          @click="requestClarifications(props.row)"
                        >
                          <i class="tim-icons icon-alert-circle-exc"></i> Request Clarifications
                        </base-button>
                        <!--<base-button
                            v-if="loggedUser.role !== UserRoles.AUDITOR"
                          class="mb-1"
                          :type="props.row.has_revision ? 'green' : 'orange'"
                          size="sm"
                          @click="requestRevision(props.row)"
                        >
                          <i class="tim-icons icon-zoom-split"></i> {{ (props.row.has_revision ? 'Open for Revision' : 'Request Revision') }}
                        </base-button>-->
                      </div>
                    </div>
                  </el-table-column>
                </el-table>
                <div
                  v-if="grant.pagination && isCN && grant.cnStatus == 1"
                  class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                  <div class="">
                    <p class="card-category">
                      Showing {{ grant.pagination.from }} to {{ grant.pagination.to }} of {{ grant.pagination.total }} entries
                    </p>
                  </div>
                  <base-pagination
                    v-if="grant.cnapplications.length"
                    @input="getItems"
                    class="pagination-no-border"
                    v-model="grant.pagination.current_page"
                    :per-page="grant.pagination.per_page"
                    :total="grant.pagination.total"
                  >
                  </base-pagination>
                </div>
              </tab-pane>
            </tabs>
          </div>
        </card>
      </div>
    </div>

    <modal
      :show.sync="modalEvaluate.visibility"
      headerClasses="justify-content-center"
      v-if="!isCN"
    >
      <h4 slot="header" class="title">Evaluate application: <strong>{{modalEvaluate.application.reference}}</strong>
      </h4>
      <!-- Evaluations for all Grants except new MG Full proposal-->
      <ol v-if="modalEvaluate.application.cn_evaluation_status != 'Preselected' && modalEvaluate.application.new_application == 0">
        <li v-for="evaluationType in evaluationTypes" :key="evaluationType.id"  v-if="evaluationType.fp == 1">
          <a @click="evaluateApplication(modalEvaluate.application, evaluationType)" class="pl-1 link-text"> {{evaluationType.name}} </a>
          <ul class="evaluations-list">
            <li v-if="applicationEvaluation.type.nickname === evaluationType.nickname" v-for="applicationEvaluation in modalEvaluate.application.evaluations" :key="applicationEvaluation.id">
              <span v-if="evaluationType.nickname === 'technical'">
                  <a @click="evaluateApplication(modalEvaluate.application, evaluationType, applicationEvaluation.user_id)" class="pl-1 link-text"> {{applicationEvaluation.status}} </a>
                ({{applicationEvaluation.user.name}})
              </span> <span v-else>{{applicationEvaluation.status}} ({{applicationEvaluation.user.name}})</span>
            </li>
          </ul>
        </li>
      </ol>
      <ol v-if="modalEvaluate.application.cn_evaluation_status != 'Preselected' && modalEvaluate.application.new_application == 1">
        <li v-for="evaluationType in evaluationTypes" :key="evaluationType.id"  v-if="evaluationType.fp == -1">
          <a @click="evaluateApplication(modalEvaluate.application, evaluationType)" class="pl-1 link-text"> {{evaluationType.name}} </a>
          <ul class="evaluations-list">
            <li v-if="applicationEvaluation.type.nickname === evaluationType.nickname" v-for="applicationEvaluation in modalEvaluate.application.evaluations" :key="applicationEvaluation.id">
              <span v-if="evaluationType.nickname === 'technical'">
                  <a @click="evaluateApplication(modalEvaluate.application, evaluationType, applicationEvaluation.user_id)" class="pl-1 link-text"> {{applicationEvaluation.status}} </a>
                ({{applicationEvaluation.user.name}})
              </span> <span v-else>{{applicationEvaluation.status}} ({{applicationEvaluation.user.name}})</span>
            </li>
          </ul>
        </li>
      </ol>
      <!--MG Full proposal Evaluations-->
      <ol v-if="modalEvaluate.application.cn_evaluation_status == 'Preselected'">
        <h4 class="mr-2"><strong>Concept Evaluations</strong></h4>
        <li v-for="evaluationType in evaluationTypes" :key="evaluationType.id"  v-if="evaluationType.fp == 0">
          <a @click="evaluateApplication(modalEvaluate.application, evaluationType)" class="pl-1 link-text"> {{evaluationType.name}} </a>
          <ul class="evaluations-list">
            <li v-if="applicationEvaluation.type.nickname === evaluationType.nickname" v-for="applicationEvaluation in modalEvaluate.application.evaluations" :key="applicationEvaluation.id">
              <span v-if="evaluationType.nickname === 'technical'">
                  <a @click="evaluateApplication(modalEvaluate.application, evaluationType, applicationEvaluation.user_id)" class="pl-1 link-text"> {{applicationEvaluation.status}} </a>
                ({{applicationEvaluation.user.name}})
              </span> <span v-else>{{applicationEvaluation.status}} ({{applicationEvaluation.user.name}})</span>
            </li>
          </ul>
        </li>
        </ol>
        <ol v-if="modalEvaluate.application.cn_evaluation_status == 'Preselected'">
          <h4 class="mr-2"><strong>Evaluations</strong></h4>
        <li v-for="evaluationType in evaluationTypes" :key="evaluationType.id"  v-if="evaluationType.fp == -1">
          <a @click="evaluateApplication(modalEvaluate.application, evaluationType)" class="pl-1 link-text"> {{evaluationType.name}} </a>
          <ul class="evaluations-list">
            <li v-if="applicationEvaluation.type.nickname === evaluationType.nickname" v-for="applicationEvaluation in modalEvaluate.application.evaluations" :key="applicationEvaluation.id">
              <span v-if="evaluationType.nickname === 'technical'">
                  <a @click="evaluateApplication(modalEvaluate.application, evaluationType, applicationEvaluation.user_id)" class="pl-1 link-text"> {{applicationEvaluation.status}} </a>
                ({{applicationEvaluation.user.name}})
              </span> <span v-else>{{applicationEvaluation.status}} ({{applicationEvaluation.user.name}})</span>
            </li>
          </ul>
        </li>
      </ol>

      <div class="mt-2 text-right">
        <base-button
          type="danger"
          @click.native="modalEvaluate.visibility = false"
        >Close
        </base-button>
      </div>
    </modal>
    <!--Concept note evaluate-->
    <modal
      :show.sync="modalEvaluate.visibility"
      headerClasses="justify-content-center"
      v-if="isCN"
    >
      <h4 slot="header" class="title">Evaluate Concept Note: <strong>{{modalEvaluate.application.reference}}</strong>
      </h4>
      <ol>
        <li v-for="evaluationType in evaluationTypes" :key="evaluationType.id" v-if="evaluationType.fp == 0">
          <a @click="evaluateApplication(modalEvaluate.application, evaluationType)" class="pl-1 link-text"> {{evaluationType.name}} </a>
          <ul class="evaluations-list">
            <li v-if="applicationEvaluation.type.nickname === evaluationType.nickname" v-for="applicationEvaluation in modalEvaluate.application.evaluations" :key="applicationEvaluation.id">
              <span v-if="evaluationType.nickname === 'technical'">
                  <a @click="evaluateApplication(modalEvaluate.application, evaluationType, applicationEvaluation.user_id)" class="pl-1 link-text"> {{applicationEvaluation.status}} </a>
                ({{applicationEvaluation.user.name}})
              </span> <span v-else>{{applicationEvaluation.status}} ({{applicationEvaluation.user.name}})</span>
            </li>
          </ul>
        </li>
      </ol>

      <div class="mt-2 text-right">
        <base-button
          type="danger"
          @click.native="modalEvaluate.visibility = false"
        >Close
        </base-button>
      </div>
    </modal>

  </card>
</template>
<script>
  import {Table, TableColumn, Select, Option} from 'element-ui';
  import {TabPane, Tabs, BaseSwitch} from 'src/components';
  import {Modal} from 'src/components';
  import {BasePagination} from 'src/components';
  import {ApplicationService, EvaluationService, GrantService, UserRoles} from '@/services';

  export default {
    components: {
      BasePagination,
      TabPane,
      Tabs,
      BaseSwitch,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Modal
    },
    data() {
      return {
        isCN: false,
        selectedYear : '2022',
        btntype22: '',
        btntype19: '',
        showToggle : true,
        UserRoles,
        initialized: false,
        pagination: {},
        sortColumn: undefined,
        sortOrder: undefined,
        perPage: 16,
        searchQuery: undefined,
        propsToSearch: ['reference', 'title', 'user_details.email', 'user_details.name', 'user_details.organisation_legal_name', 'region_details.name', 'countries.name', 'status'],
        grants: [],
        currentGrantId: 0,
        applications: [],
        cnapplications: [],
        filterOptions: [],
        cnfilterOptions: [],
        filters: {
          status: undefined,
          countries: [],
          regions: [],
          language: undefined
        },
        cnfilters: {
          status: undefined,
          countries: [],
          regions: [],
          language: undefined
        },
        evaluationTypes: [],
        modalEvaluate: {
          visibility: false,
          application: {}
        },
        switch1: true,
      };
    },
    computed: {
      loggedUser() {
        return this.$store.getters['Auth/loggedUser'];
      },
      languages: function () {
        let availableLanguages = this.$store.getters['Localization/languages'];
        let languages = [];
        for (let key in availableLanguages) {
          languages[availableLanguages[key].language] = availableLanguages[key];
        }
        return languages;
      }
    },
    methods: {
      async getItems(page) {
        let vm = this;
        let page_to_get = page || vm.pagination.current_page;

        let loader = vm.$loading.show();
  if(!vm.isCN){
        await GrantService.all().then((response) => {
          vm.grants = response.data;

          if (vm.currentGrantId === 0) {
            vm.currentGrantId = vm.grants[0].grantId;
          }
        })
        //let applicationyear = ""
        /*if(vm.currentGrantId == 2 || vm.currentGrantId == 3){
          applicationyear = vm.selectedYear;
        }*/
        vm.getEvaluationTypes();

        for (let i = 0; i < vm.grants.length; i++) {
          await ApplicationService.getApplications({
            page: page_to_get,
            per_page: vm.perPage,
            grant_id: vm.grants[i].grantId,
            search: vm.searchQuery,
            sort_column: vm.sortColumn,
            sort_direction: vm.sortDirection,
            filter_status: vm.filters.status,
            filter_final_status: vm.filters.final_status,
            filter_regions: vm.filters.regions,
            filter_countries: vm.filters.countries,
            filter_language: vm.filters.language,
            application_year: (vm.grants[i].grantId == 2 || vm.grants[i].grantId == 3) ? vm.selectedYear : "",
          }).then((response) => {
            vm.grants[i].applications = response.data.data;
            vm.grants[i].pagination = response.data.meta;
          })
        }

        await vm.getFilters();
  }
  //else{

    if(vm.isCN){
      for (let i = 0; i < vm.grants.length; i++) { 
          if(vm.grants[i].cnStatus == 1){
              await ApplicationService.getConceptNotes({
                page: page_to_get,
                per_page: vm.perPage,
                grant_id: vm.grants[i].grantId,
                search: vm.searchQuery,
                sort_column: vm.sortColumn,
                sort_direction: vm.sortDirection,
                filter_status: vm.cnfilters.status,
                evaluation_status: vm.cnfilters.evaluation_status,
                filter_regions: vm.cnfilters.regions,
                filter_countries: vm.cnfilters.countries,
                filter_language: vm.cnfilters.language,
              }).then((response) => {
                vm.grants[i].cnapplications = response.data.data;
                vm.grants[i].pagination = response.data.meta;
              })
          }
      }
        await vm.getConceptFilters();
      }
  //}
        loader.hide();
      },
      async getFilters() {
        let vm = this;
        //let applicationyear = ""
        /*if(vm.currentGrantId == 2 || vm.currentGrantId == 3){
          applicationyear = vm.selectedYear;
        }*/
        return await ApplicationService.getFilters({
          search: vm.searchQuery,
          grant_id: vm.currentGrantId,
          filter_status: vm.filters.status,
          filter_final_status: vm.filters.final_status,
          filter_regions: vm.filters.regions,
          filter_countries: vm.filters.countries,
          filter_language: vm.filters.language,
          application_year: (vm.currentGrantId == 2 || vm.currentGrantId == 3) ? vm.selectedYear : "",
        }).then((response) => {
          vm.filterOptions = response.data;
        })
      },
      
      async getConceptFilters() {
        let vm = this;
        return await ApplicationService.getConceptFilters({
          search: vm.searchQuery,
          grant_id: vm.currentGrantId,
          filter_status: vm.cnfilters.status,
          evaluation_status: vm.cnfilters.evaluation_status,
          filter_regions: vm.cnfilters.regions,
          filter_countries: vm.cnfilters.countries,
          filter_language: vm.cnfilters.language,
        }).then((response) => {
          vm.cnfilterOptions = response.data;
        })
      },
      async getEvaluationTypes() {
        let vm = this;
        let response = await EvaluationService.getEvaluationTypes(vm.currentGrantId);
        vm.evaluationTypes = response.data;
      },
      activateTab(ev) {
        let vm = this;
        vm.isCN = vm.isCN == true ? false : vm.isCN;
        vm.currentGrantId = +ev.id.replace('grants_', '');
        vm.getFilters();
        vm.getEvaluationTypes();
        //this.getItems(1);
      },
      yearWiseMediumGrant(filterYear,grantId){
        if(filterYear == '2022'){
          this.selectedYear = 2022;
          this.showToggle = true;
          this.getItems(1);
          this.btntype22 = 'secondary';
          this.btntype19 = 'info';

        }
        else{
          this.showToggle = false;
          this.selectedYear = 2019;
          this.getItems(1);
          this.btntype22 = 'info';
          this.btntype19 = 'secondary';
        }
        this.currentGrantId = grantId;
        
      },
      handleFilters(grantId) {
        let vm = this;
        vm.currentGrantId = grantId;

        vm.getItems(1);
      },
      handleSort(data) {
        let vm = this;
        let direction = null;
        if (data.order === 'ascending') {
          direction = 'asc';
        } else if (data.order === 'descending') {
          direction = 'desc';
        }
        vm.sortColumn = data.prop;
        vm.sortDirection = direction;
        vm.getItems(1);
      },
      viewUserProfile(userId) {
        this.$router.push('/users-management/view-profile/' + userId);
      },
      viewApplication(application, openInNewTab) {
        let vm = this;
        //view concept-note application
        if(vm.isCN){
          if (openInNewTab) {
            //window.open('/application/fill/' + application.grant_id + '/' + application.application_id + '/' + "conceptNote", '_blank');
            let routeData = this.$router.resolve({
              name: "ConceptFill",
              params: { grantId: application.grant_id, applicationId: application.application_id, conceptStatus: "conceptNote" },
              });
              window.open(routeData.href, '_blank');
          } else {
            //this.$router.push('/application/fill/' + application.grant_id + '/' + application.application_id + '/' + "conceptNote");
            this.$router.push({
              name: "ConceptFill",
              params: { grantId: application.grant_id, applicationId: application.application_id, conceptStatus: "conceptNote" },
              });
          }
        }
        else if(application.cn_evaluation_status == "Preselected"){
          if (openInNewTab) {
            //window.open('/application/fill/' + application.grant_id + '/' + application.application_id + '/' + application.cn_evaluation_status, '_blank');
            let routeData = this.$router.resolve({
              name: "ConceptFill",
              params: { grantId: application.grant_id, applicationId: application.application_id, conceptStatus: application.cn_evaluation_status },
              });
              window.open(routeData.href, '_blank');
          } else {
            //this.$router.push('/application/fill/' + application.grant_id + '/' + application.application_id + '/' + application.cn_evaluation_status);
            this.$router.push({
              name: "ConceptFill",
              params: { grantId: application.grant_id, applicationId: application.application_id, conceptStatus: application.cn_evaluation_status },
              });
          }
        }
        else{
          /*if (openInNewTab) {
            window.open('/application/fill/' + application.grant_id + '/' + application.application_id, '_blank');
          } else {
            this.$router.push('/application/fill/' + application.grant_id + '/' + application.application_id);
          }*/
          if (openInNewTab) {
            //window.open('/application/fill/' + application.grant_id + '/' + application.application_id + '/' + application.cn_evaluation_status, '_blank');
            let routeData = this.$router.resolve({
              name: "Fill",
              params: { grantId: application.grant_id, applicationId: application.application_id, appversion: application.new_application },
              });
              window.open(routeData.href, '_blank');
          } else {
            //this.$router.push('/application/fill/' + application.grant_id + '/' + application.application_id + '/' + application.cn_evaluation_status);
            this.$router.push({
              name: "Fill",
              params: { grantId: application.grant_id, applicationId: application.application_id, appversion: application.new_application },
              });
          }
        }
      },
      evaluateApplicationModal(application) {
        let vm = this;
        vm.modalEvaluate.visibility = true;
        vm.modalEvaluate.application = application;
      },
      evaluateApplication(application, evaluationType, evaluationUserId) {
        if (evaluationUserId) {
          window.open('/application/evaluate/' + evaluationType.nickname + '/' + application.application_id + '/' + evaluationUserId, '_blank');
        } else {
          window.open('/application/evaluate/' + evaluationType.nickname + '/' + application.application_id, '_blank');
        }
      },
      requestClarifications(application) {
        this.$router.push('/clarifications/fill/' + application.application_id);
      },
      requestRevision(application) {
        if (application.has_revision)
        {
            if(application.cn_evaluation_status == "Preselected"){
              //this.$router.push('/application/fill/' + application.grant_id + '/' + application.application_id + '/' + application.cn_evaluation_status);
              this.$router.push({
              name: "ConceptFill",
              params: { grantId: application.grant_id, applicationId: application.application_id, conceptStatus: application.cn_evaluation_status },
              });
            }
            else{
              //this.$router.push('/application/fill/' + application.grant_id + '/' + application.application_id);
              this.$router.push({
              name: "Fill",
              params: { grantId: application.grant_id, applicationId: application.application_id, appversion: application.new_application },
              });
            }
          // if (openInNewTab) {
          //   window.open('/application/fill/' + application.grant_id + '/' + application.application_id, '_blank');
          // } else {
            //this.$router.push('/application/fill/' + application.grant_id + '/' + application.application_id);
          //}
        }
        else
        {
          ApplicationService.requestRevision({
            application_id: application.application_id,
            user_id: application.user_id,
          }).then((response) => {
            application.has_revision = true;
          });
        }
      },
      exportEvaluation(application_id, name)
      {
        let vm = this;
        let loader = vm.$loading.show();

        EvaluationService.exportEvaluation({
          application_id: application_id,
          name: name,
        }).then((response) => {
          if (response.data && response.data.success)
          {
            window.open(response.data.url, '_blank');
          }

          loader.hide();
        });
      },
      exportConceptEvaluation(application_id, name)
      {
        let vm = this;
        let loader = vm.$loading.show();

        EvaluationService.exportConceptEvaluation({
          application_id: application_id,
          name: name,
        }).then((response) => {
          if (response.data && response.data.success)
          {
            window.open(response.data.url, '_blank');
          }

          loader.hide();
        });
      },
      exportConceptNoteBulk(){
        let vm = this;
        let loader = vm.$loading.show();
        ApplicationService.exportConceptNoteBulk({
            grant_id: vm.currentGrantId,
            search: vm.searchQuery,
            sort_column: vm.sortColumn,
            sort_direction: vm.sortDirection,
            filter_status: vm.cnfilters.status,
            evaluation_status: vm.cnfilters.evaluation_status,
            filter_regions: vm.cnfilters.regions,
            filter_countries: vm.cnfilters.countries,
            filter_language: vm.cnfilters.language,
            application_year: vm.selectedYear,
          }).then((response) => {
          if (response.data && response.data.success)
          {
            window.open(response.data.download_link, '_blank');
          }

          loader.hide();
        });
      }
    },
    mounted() {
      let vm = this;
      vm.getItems();
      //vm.getEvaluationTypes();
      this.btntype22 = 'secondary';
      this.btntype19 = 'info';
    }
  };
</script>
<style lang="scss" scoped>
  .card-body {
    button {
      margin-left: 1rem;
    }
  }

  .dropdown-menu li
  {
    padding: 5px 20px;
    cursor: pointer;
    white-space: nowrap;
  }

  .dropdown-menu a
  {
    width: 100%;
  }

  button {
    white-space: nowrap;
  }

  .evaluations-list {
    list-style-type: disc !important;
  }
</style>

<style>
  .el-table,
  .el-table .cell,
  .el-table__body-wrapper
  {
    overflow: visible !important;
  }
  .btn22{
    background-color: red!important;
  }
  .cn-export-csv{
    float: right;
  }
</style>
